(ns ui.view.sheets.sub
  (:require
   [re-frame.core :as rf]
   [ui.view.sheets.model :as model]))

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db model/root-path)))

(rf/reg-sub
 ::sheet-stack
 :<- [::state]
 (fn [state]
   (get-in state model/sheet-stack-path [])))

(rf/reg-sub
 ::sheets
 :<- [::sheet-stack]
 (fn [sheet-stack]
   (let [sheet-count (count sheet-stack)
         open-sheets (filterv :open? sheet-stack)
         open-sheet-count (count open-sheets)
         topmost-sheet-width (-> open-sheets
                                 first
                                 :width)
         closing-sheet-count (->> sheet-stack
                                  (remove :open?)
                                  count)
         sheets (->> sheet-stack
                     (map-indexed
                      (fn [index sheet]
                        (let [sheet-id (:id sheet)
                              position (- index closing-sheet-count)]
                          (-> sheet
                              (assoc :sheet-id sheet-id
                                     :position position
                                     :sheets-before position
                                     :sheet-count sheet-count
                                     :open-sheet-count open-sheet-count
                                     :topmost? (zero? position)
                                     :topmost-sheet-width (if (zero? open-sheet-count)
                                                            (:width sheet)
                                                            topmost-sheet-width))))))
                     vec)]
     sheets)))
